import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import Pricing from "../components/pricing"
import Footer from "../components/footer";
// One header, not two. components/navbar.js offered five destinations (Home,
// About Us, Pricing, Contact, Community) and sent Login and Contact to
// hevolvechat.hertzai.com, a different product on a different domain. This one
// carries the whole site and keeps the reader on it. See Layouts/header.js.
import HeaderNano from "./Layouts/header";
import useDarkPage from '../hooks/useDarkPage';

export default function Pricings() {

    // Starts false, which is what the prerenderer captured and what every
    // browser ends at.
    //
    // It used to start true, and the effect below immediately set it to false in
    // anything that is not the Android webview. The prerenderer captures AFTER
    // effects, so the saved file has the header while the first client render
    // did not, and hydration answered with "Expected server HTML to contain a
    // matching <section> in <div>, at Pricings" and threw the page away.
    //
    // Inside hevolvedroid the effect still hides the navbar a moment after
    // mount, which is the same order of events as before for that one client.
    const [hevolvedroid, setIshevolvedroid] = useState(false);

    useEffect(() => {
        const userAgent = navigator.userAgent;
        setIshevolvedroid(userAgent.includes('hevolvedroid'));
      }, []);
    
    useDarkPage();
    useEffect(() => {


    }, []);


    return (
        <>
         {!hevolvedroid  && <HeaderNano />}
            
            <section style={{ paddingTop: '4rem' }} className="relative mt-4">
                <div className="container relative" >
                    <div className="grid grid-cols-1 text-center ">
                        <div>
                            <h1 className="md:text-4xl text-3xl md:leading-normal leading-normal tracking-wider font-semibold text-white mb-0">Pricing Plans</h1>
                        </div>

                        <ul className="tracking-[0.5px] mb-0 inline-block ">
                            <li className="inline-block capitalize text-[15px] font-medium duration-500 ease-in-out text-white/50 hover:text-white"><Link to="/">Hevolve AI</Link></li>
                            <li className="inline-block text-base text-white/50 mx-0.5 ltr:rotate-0 rtl:rotate-180"><i className="mdi mdi-chevron-right"></i></li>
                            <li className="inline-block capitalize text-[15px] font-medium duration-500 ease-in-out text-white" aria-current="page">Pricing</li>
                        </ul>
                    </div>
                </div>
            </section>


            <section className="relative md:pb-24 pb-16">

                <div className="container relative ">

                    <Pricing />
                </div>

            </section>

            {
                !hevolvedroid && <Footer />
            }

        </>
    )
}